import type * as d3 from 'd3'

import type { ChartScales } from '@/features/bidding/types/bidLadder'

type ClearingRangeForecastData = {
  p80High: number
  p80Low: number
  meanPrice: number
}

export function renderClearingRange(
  g: d3.Selection<SVGGElement, unknown, null, undefined>,
  scales: ChartScales,
  forecastData: ClearingRangeForecastData,
  market: 'up' | 'down',
  visibilityState: Map<string, boolean>,
) {
  const { yScale, chartWidth, xScale } = scales
  const clearingGroup = g.append('g').attr('class', `clearing-range-${market}`)

  const legendKey = market === 'up' ? 'Clearing Range Up' : 'Clearing Range Down'
  const isVisible = visibilityState.get(legendKey) ?? true

  // Market-specific colors - richer tints
  const color = market === 'up' ? '#10b981' : '#ef4444'

  const p80HighY = yScale(forecastData.p80High)
  const p80LowY = yScale(forecastData.p80Low)
  const regionHeight = p80LowY - p80HighY

  // For butterfly chart, only show clearing range on the relevant half
  const centerX = xScale(0)
  const rectX = market === 'up' ? centerX : 0
  const rectWidth = market === 'up' ? chartWidth - centerX : centerX

  const rect = clearingGroup
    .append('rect')
    .attr('x', rectX)
    .attr('y', p80HighY)
    .attr('width', rectWidth)
    .attr('height', regionHeight)
    .attr('fill', color)
    .attr('opacity', isVisible ? 0.12 : 0)

  // Mean price line (only on relevant side) - solid line for clarity
  const meanY = yScale(forecastData.meanPrice)
  clearingGroup
    .append('line')
    .attr('x1', rectX)
    .attr('x2', rectX + rectWidth)
    .attr('y1', meanY)
    .attr('y2', meanY)
    .attr('stroke', color)
    .attr('stroke-width', 0.5)
    .attr('opacity', isVisible ? 0.6 : 0)

  return rect
}
